module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-SemiBold-4b7b0ab62a20555e4a7ac530d55c5a6c.woff";